// safe area

export const safeAreaAbove = () => values.SAFE_ABOVE;

export const safeAreaBelow = () => values.SAFE_BELOW;

export const keyboardHeight = () => values.KEYBOARD_HEIGHT;

export const safeAreaKeyboard = () => values.SAFE_KEYBOARD;

// values

const getValues = () =>
{
    const root = document.documentElement;
    const styles = window.getComputedStyle(root);
    const value = (style: string) => parseFloat(styles.getPropertyValue(style) || "0");

    const FONT_SIZE = value("font-size");
    const SAFE_ABOVE = value("--safe-area-top");
    const SAFE_BELOW = value("--safe-area-bottom");
    const KEYBOARD_HEIGHT = value("--keyboard-height");
    const SAFE_KEYBOARD = Math.max(SAFE_BELOW, KEYBOARD_HEIGHT);

    root.style.setProperty("--safe-area-keyboard", `${SAFE_KEYBOARD}px`);

    return {
        FONT_SIZE,
        SAFE_ABOVE,
        SAFE_BELOW,
        SAFE_KEYBOARD,
        KEYBOARD_HEIGHT,
    };
};

const values = getValues();

export const updateValues = () =>
{
    Object.assign(values, getValues());

    window.dispatchEvent(new Event("InsetsChanged"));
};
